<h3 mat-dialog-title class="title">{{ 'LABEL.CHANGE_PWD' | translate }}</h3>
<mat-dialog-content>
    <form [formGroup]="form" class="flex-col lt password-form">
        <label for="old-pwd" class="label-control">{{'LABEL.PASSWORD' | translate}}</label>
        <mat-form-field appearance="outline" class="form" color="accent">
            <input #oldpwd type="password" id="old-pwd" formControlName="currentPassword" matInput [placeholder]="'LABEL.PASSWORD' | translate">
            <button type="button" mat-icon-button matSuffix (click)="toggleVisiblePassword(oldpwd)">
                <mat-icon>{{ oldpwd.type == 'text' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <mat-icon matPrefix svgIcon="password"></mat-icon>
        </mat-form-field>
        <ng-container *ngIf="currentPassword.errors">
            <mat-error @fade *ngIf="currentPassword.errors.incorrect">{{ 'MSG.INCORRECT_PWD' | translate }}</mat-error>
            <mat-error @fade *ngIf="currentPassword.errors.required && currentPassword.touched">{{ 'MSG.PASSWORD_REQUIRED' | translate }}</mat-error>
        </ng-container>
        <label for="pwd" class="label-control">{{'LABEL.NEW_PASSWORD' | translate}}</label>
        <mat-form-field appearance="outline" class="form" color="accent">
            <input #pwd type="password" id="pwd" formControlName="password" matInput [placeholder]="'LABEL.NEW_PASSWORD' | translate">
            <button type="button" mat-icon-button matSuffix (click)="toggleVisiblePassword(pwd)">
                <mat-icon>{{ pwd.type == 'text' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <mat-icon matPrefix svgIcon="password"></mat-icon>
        </mat-form-field>
        <ng-container *ngIf="pwdControl.errors">
            <mat-error @fade *ngIf="pwdControl.errors.required && pwdControl.touched">
                {{ 'MSG.NEW_PWD_REQUIRED' | translate }}
            </mat-error>
            <mat-error @fade *ngIf="pwdControl.errors.pattern">
                {{ 'MSG.PASSWORD_MUST_MATCH_PATTERN' | translate }}
            </mat-error>
        </ng-container>

        <label for="re-pwd" class="label-control">{{'LABEL.CONFIRM_NEW_PASSWORD' | translate}}</label>
        <mat-form-field appearance="outline" class="form" color="accent">
            <input #repwd type="password" id="re-pwd" formControlName="confirmPassword" matInput [placeholder]="'LABEL.CONFIRM_NEW_PASSWORD' | translate">
            <button type="button" mat-icon-button matSuffix (click)="toggleVisiblePassword(repwd)">
                <mat-icon>{{ repwd.type == 'text' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <mat-icon matPrefix svgIcon="password"></mat-icon>
        </mat-form-field>
        <ng-container *ngIf="repwdControl.errors">
            <mat-error @fade *ngIf="repwdControl.errors.required && repwdControl.touched">
                {{ 'MSG.CONFIRM_NEW_PWD_REQUIRED' | translate }}
            </mat-error>
            <mat-error @fade *ngIf="repwdControl.errors.pattern">
                {{ 'MSG.PASSWORD_MUST_MATCH_PATTERN' | translate }}
            </mat-error>
        </ng-container>

        <mat-error @fade *ngIf="repwdControl.touched && form.errors?.notSame">{{ 'MSG.PASSWORD_NOT_SAME' | translate }}</mat-error>
        <mat-error @fade *ngIf="form.errors?.same">{{ 'MSG.OLD_NEW_PWD_SAME' | translate }}</mat-error>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="action">
        <button mat-stroked-button color="grey"  mat-dialog-close>{{ 'LABEL.CANCEL' | translate }}</button>
        <button mat-flat-button color="accent" type="submit" (click)="onChangePassword()" [disabled]="processing">{{ 'LABEL.SAVE' | translate }}</button>
    </div>
</mat-dialog-actions>